import type { NotFoundMessageProps } from './not-found-message.interface';
import type { FC } from 'react';

import React from 'react';

export const NotFoundMessage: FC<NotFoundMessageProps> = ({
  message,
}: NotFoundMessageProps) => (
  <p className={'message message_not-found'}>{message}</p>
);
